export const CONFIG = {
  5000: {
    8: [
      {
        top: "-305px",
        left: "-700px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-305px",
        left: "auto",
        right: "-700px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "-105px",
        left: "-775px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-105px",
        left: "auto",
        right: "-775px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "95px",
        left: "-775px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "95px",
        left: "auto",
        right: "-775px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "295px",
        left: "-700px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "295px",
        left: "auto",
        right: "-700px",
        bottom: "auto",
        isRevert: true,
      },
    ],
    7: [
      {
        top: "-305px",
        left: "-700px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-225px",
        left: "auto",
        right: "-725px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "-105px",
        left: "-775px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "0px",
        left: "auto",
        right: "-775px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "95px",
        left: "-775px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "225px",
        left: "auto",
        right: "-725px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "295px",
        left: "-700px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "295px",
        left: "auto",
        right: "-700px",
        bottom: "auto",
        isRevert: true,
      },
    ],
    6: [
      {
        top: "-225px",
        left: "-725px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-225px",
        left: "auto",
        right: "-725px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "0px",
        left: "-795px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "0px",
        left: "auto",
        right: "-795px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "225px",
        left: "-725px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "225px",
        left: "auto",
        right: "-725px",
        bottom: "auto",
        isRevert: true,
      },
    ],
    5: [
      {
        top: "-225px",
        left: "-725px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-125px",
        left: "auto",
        right: "-795px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "0px",
        left: "-795px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "125px",
        left: "auto",
        right: "-795px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "225px",
        left: "-725px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    4: [
      {
        top: "-125px",
        left: "-795px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-125px",
        left: "auto",
        right: "-795px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "125px",
        left: "-795px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "125px",
        left: "auto",
        right: "-795px",
        bottom: "auto",
        isRevert: true,
      },
    ],
    3: [
      {
        top: "-125px",
        left: "-795px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "0px",
        left: "auto",
        right: "-775px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "125px",
        left: "-795px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    2: [
      {
        top: "0px",
        left: "-775px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "0px",
        left: "auto",
        right: "-775px",
        bottom: "auto",
        isRevert: true,
      },
    ],
  },
  1536: {
    8: [
      {
        top: "-215px",
        left: "-600px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-215px",
        left: "auto",
        right: "-600px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "-65px",
        left: "-675px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-65px",
        left: "auto",
        right: "-675px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "75px",
        left: "-675px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "75px",
        left: "auto",
        right: "-675px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "215px",
        left: "-600px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "215px",
        left: "auto",
        right: "-600px",
        bottom: "auto",
        isRevert: true,
      },
    ],
    7: [
      {
        top: "-215px",
        left: "-600px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-150px",
        left: "auto",
        right: "-620px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "-65px",
        left: "-675px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "0px",
        left: "auto",
        right: "-675px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "75px",
        left: "-675px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "150px",
        left: "auto",
        right: "-620px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "215px",
        left: "-600px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    6: [
      {
        top: "-150px",
        left: "-620px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-150px",
        left: "auto",
        right: "-620px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "0px",
        left: "-675px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "0px",
        left: "auto",
        right: "-675px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "150px",
        left: "-620px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "150px",
        left: "auto",
        right: "-620px",
        bottom: "auto",
        isRevert: true,
      },
    ],
    5: [
      {
        top: "-150px",
        left: "-620px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-70px",
        left: "auto",
        right: "-650px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "0px",
        left: "-675px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "70px",
        left: "auto",
        right: "-650px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "150px",
        left: "-620px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    4: [
      {
        top: "-70px",
        left: "-650px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "-70px",
        left: "auto",
        right: "-650px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "70px",
        left: "-650px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "70px",
        left: "auto",
        right: "-650px",
        bottom: "auto",
        isRevert: true,
      },
    ],
    3: [
      {
        top: "-70px",
        left: "-650px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "0px",
        left: "auto",
        right: "-625px",
        bottom: "auto",
        isRevert: true,
      },
      {
        top: "70px",
        left: "-650px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    2: [
      {
        top: "00px",
        left: "-625px",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "0px",
        left: "auto",
        right: "-625px",
        bottom: "auto",
        isRevert: true,
      },
    ],
  },
  992: {
    8: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    6: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    5: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    4: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    3: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    2: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
  },
  600: {
    8: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    6: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    5: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    4: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    3: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
    2: [
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
      {
        top: "auto",
        left: "auto",
        right: "auto",
        bottom: "auto",
        isRevert: false,
      },
    ],
  },
};
